import { useMemo, useState } from 'react'

import { resourceListTag, useWindow, useQueryResult } from '@krp/client-runtime'
import {
  MAX_SNAPSHOT_PAGES,
  ONEC_SUPPLY_TAG,
  ReceiptsScreen,
  makeSelectReceiptsVm,
  normalizeRid,
  onecSupplyReceipts,
  suppliesApi,
  type ReceiptsActions,
  type SupplyReceiptsArgs,
} from '@krp/resource-onec-ui'

import { useAppDispatch } from '../../app/hooks'

/** Binding приходных 1С: только чтение базы окна. Число страниц — состояние экрана, не слайса. */
export function SupplyReceiptsBinding() {
  const window = useWindow()
  const dispatch = useAppDispatch()
  const resourceId = normalizeRid(window.params.rid ?? '')
  const [pages, setPages] = useState(1)
  const args = useMemo<SupplyReceiptsArgs | null>(() => (resourceId === '' ? null : { resourceId, pages }), [resourceId, pages])
  const receipts = useQueryResult(onecSupplyReceipts, args)
  const selectVm = useMemo(() => makeSelectReceiptsVm(), [])
  const vm = selectVm({ receipts })
  const actions = useMemo<ReceiptsActions>(
    () => ({
      loadMore: () => setPages((value) => Math.min(value + 1, MAX_SNAPSHOT_PAGES)),
      reload: () => dispatch(suppliesApi.util.invalidateTags([resourceListTag(ONEC_SUPPLY_TAG, resourceId)])),
      close: window.close,
    }),
    [dispatch, resourceId, window.close],
  )
  return <ReceiptsScreen vm={vm} actions={actions} />
}
